import { isUndefined } from 'lodash'
import uiCommonGetters from '@/store/ui/common/getters'

const getters = {
    audienceVolumeIsLoadingById: state => audienceId => {
        const key = `volume/${audienceId}`
        return isUndefined(state.isLoading[key]) || state.isLoading[key]
    },
    ...uiCommonGetters
}

export default getters
